import { BiSearch } from 'react-icons/bi';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CustomSearchBar = ({ onChange, label, doShowSearchIcon, value }) => (
  <div className="relative">
    <input
      onChange={(event) => {
        const { value: inputValue } = event.target;
        onChange(inputValue);
      }}
      value={value}
      type="text"
      placeholder={label}
      style={{ paddingTop: '10px', paddingBottom: '10px' }}
      className={clsx(
        'w-full pr-4 text-sm text-gray-700 bg-white border rounded-2xl shadow-sm focus:outline-none focus:border-gray-300',
        doShowSearchIcon ? 'pl-10' : 'pl-2',
      )}
    />

    {doShowSearchIcon && (
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 ">
        <BiSearch size={22} color="gray" />
      </div>
    )}
  </div>
);

CustomSearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  doShowSearchIcon: PropTypes.bool,
  value: PropTypes.string,
};

CustomSearchBar.defaultProps = {
  label: 'Search by Keyword...',
  doShowSearchIcon: true,
  value: undefined,
};
export default CustomSearchBar;
